import React, { useEffect, useRef, useState } from 'react';
import {
	cleanDataOfManagedReceptionist,
	createCheckoutSessionNewResellers,
	decrementUnreservedReceptionist,
	deleteReceptionist,
	fetchResellerTestClients,
	ResellerDashboardLink,
	updateManagedReceptionist,
	convertTrialReceptionist,
	stripeCancelOrUpdate,
	endTrial,
	getSubscriptionUnitPrice,
	UpdateAutoScaleReceptionist,
	updateTutorialStepStatus,
	updateTourStatus,
	manageSubAccount,
	copySubAccount,
} from '@/api/reseller';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getResellerData } from '@/store/reseller/selector';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
	Input,
	InputNumber,
	notification,
	Switch,
	Row,
	Col,
	Typography,
	Select,
	Modal,
	Form,
	Divider,
	Button,
	Dropdown,
	Menu,
	Tooltip,
	TourStepProps,
} from 'antd';
import { CustomModal } from '@/components/CustomModal';
import { requestIntegration } from '@/api/user';
import { currentSubscriptionInformation } from '@/api/user';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { setAccount } from '@/store/account/slice';
import { Loading } from '@/components/Loading';
import { updateReseller, updateResellerClients, setTrialStatus } from '@/store/reseller/slice.js';
import { AddCircleOutlineOutlined, CopyAll } from '@mui/icons-material';
import ResellerDashboard from '../ResellerDashboard.tsx';
import { ResellerSiderItem } from 'src/enums/IResellerSiderItems.ts';
import LocalStorageUtility from '@/utils/localStorage.ts';
import { LocalStorageKeys } from 'src/enums/ELocalStorage.ts';
import { useGetResellerClients } from 'src/Hooks/resellerHooks.ts';
import { getTwilioBundleStatus } from '@/api/reservedNumbers.ts';
import { AppRoutes } from 'src/enums/ERoutes.ts';
import {
	CloseOutlined,
	CopyOutlined,
	DeleteOutlined,
	InfoCircleOutlined,
	PlusCircleOutlined,
	SettingOutlined,
	ShoppingCartOutlined,
} from '@ant-design/icons';
import FeatureGatingCustomizeModal from '../Reseller_Common_Components/FeatureGatingCustomizeModal.tsx';
import DownloadCallLogsModal from './DownloadCallLogsModal';
import {
	BookOpenIcon,
	ChevronRight,
	CircleDollarSign,
	CopyIcon,
	Globe,
	PlusCircle,
	SettingsIcon,
	SparklesIcon,
	Tag,
	User,
} from 'lucide-react';
import ClientList from './ClientList.tsx';
import { openModal } from '@/store/modal/slice.ts';
import { MODAL_IDS } from 'src/enums/EModal.ts';
// import { ManageCreditsModal } from './ManageCredits/ManageCreditsModal.tsx';
import { getResellerTrialStatus } from '@/store/reseller/selector';
import TutorialsModal from '../TutorialsModal.tsx';

import '../ResellerDashboard.scss';
import UserRegistrationPage from '@/pages/UserRegistration/UserRegistrationPage.tsx';
import { ReceptionistDashboard } from '@/pages/ReceptionistDashboard/ReceptionistDashboard.tsx';
import { updateDefaultRegistration } from '../../../api/reseller';
import { useSearchParams } from 'react-router-dom'; // Add this import
import CsmCard from './CsmCard.tsx';
import { CSM_MEMBERS } from 'src/constants.ts';
import TourButton from '@/components/TourButton/TourButton.tsx';
import ResellerTour from '../ResellerTour/ResellerTour.tsx';
import { setTour } from '@/store/resellerTour/slice.ts';
import { getResellerTourState } from '@/store/resellerTour/selector.ts';
import { User as TypeUser, UserAccount } from '@/types/TAccounts.ts';

const { TextArea } = Input;
const { Option } = Select;

const { Title, Text } = Typography;

const tutorialItems = [
	{
		icon: (
			<div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
				<CopyIcon className="text-blue-500" size={20} />
			</div>
		),
		title: 'Copy existing receptionists',
		description: 'Copying Existing Receptionists in My AI Frontdesk',
		url: 'https://www.myaifrontdesk.com/reseller-tutorials/copying-existing-receptionists-in-my-ai-frontdesk',
	},
	{
		icon: (
			<div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
				<SettingsIcon className="text-blue-500" size={20} />
			</div>
		),
		title: 'Setting up a subaccount',
		description: 'Setting Up a Subaccount in Your Admin Dashboard - White Glove Approach',
		url: 'https://www.myaifrontdesk.com/reseller-tutorials/setting-up-a-subaccount-in-your-admin-dashboard',
	},
];

const businessTypes = [
	'Retail',
	'Healthcare',
	'Technology',
	'Financial Services',
	'Education',
	'Manufacturing',
	'Hospitality',
	'Other',
];

const revenueRanges = [
	{ value: 'under100k', label: 'Under $100K' },
	{ value: '100k-500k', label: '$100K - $500K' },
	{ value: '500k-1M', label: '$500K - $1M' },
	{ value: '1M-5M', label: '$1M - $5M' },
	{ value: '5M-10M', label: '$5M - $10M' },
	{ value: 'over10M', label: 'Over $10M' },
];

export default function MyReceptionist() {
	const resellerData = useAppSelector(getResellerData);
	const queryClient = useQueryClient();

	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	const [clients, setClients] = React.useState<any[]>([]);
	const [sandBoxClients, setSandBoxClients] = React.useState<any[]>([]);
	const [trialClients, setTrialClients] = React.useState<any[]>([]);
	const [isRegistrationModalActive, setIsRegistrationModalActive] = React.useState<boolean>(false);
	const [successConfigureReceptionistModal, setSuccessConfigureReceptionistModal] =
		React.useState<boolean>(false);
	const [deleteReceptionistNoticeModal, setDeleteReceptionistNoticeModal] =
		React.useState<boolean>(false);
	const [clearAllLogsWarningModal, setClearAllLogsWarningModal] = React.useState<boolean>(false);
	const [receptionistCurrentlySelected, setCurrentReceptionist] = React.useState<{
		number: string;
		max_minutes?: number;
		accountInfo: UserAccount;
	} | null>(null);
	const [changeMangedReceptionistPasswordModal, setChangeMangedReceptionistPasswordModal] =
		React.useState<boolean>(false);
	const [resellerMinutesLimitationModal, setResellerMinutesLimitationModal] =
		React.useState<boolean>(false);
	const [purchaseSeatsModal, setPurchaseSeatsModal] = React.useState<boolean>(false);
	const [noSeatsAvailableModal, setNoSeatsAvailableModal] = React.useState<boolean>(false);
	const [newPassword, setNewPassword] = React.useState<string>('');
	const [maxMinutes, setMaxMinutes] = React.useState<number | null>(60); // Default max_minutes value
	const [minutesLimitEnabled, setMinutesLimitEnabled] = React.useState<boolean>(false); // Default enabled value
	const [removeSubscriptionModal, setRemoveSubscriptiontNoticeModal] =
		React.useState<boolean>(false);
	const [seatsBuyed, setSeatsBuyed] = React.useState<number | null>(1);
	const [copyReceptionistModal, setCopyReceptionistModal] = React.useState<boolean>(false);
	const [copiedReceptiontCreds, setCopiedReceptiontCreds] = React.useState({
		username: '',
		password: '',
		email: '',
		businessName: '',
	});

	const [previewDashboardModalIsOpen, setPreviewDashboardModalIsOpen] =
		React.useState<boolean>(false);
	// const [currentClient, setCurrentClient] = React.useState<string | null>(null);
	const [embedLinkModal, setEmbedLinkModal] = React.useState<boolean>(false);
	const [embedTrialLinkModal, setEmbedTrialLinkModal] = React.useState<boolean>(false);
	const [accountModal, setAccountModal] = React.useState<boolean>(false);
	const [trialAccountModal, setTrialAccountModal] = React.useState<boolean>(false);
	const isResellerOnTrial = useAppSelector(getResellerTrialStatus);

	const [embedOptionsModal, setEmbedOptionsModal] = useState(false);
	const [embedLoginModal, setEmbedLoginModal] = useState(false);
	const [embedRegisterOptionsModal, setEmbedRegisterOptionsModal] = useState(false);

	const [registrationType, setRegistrationType] = useState<'trial' | 'paid' | null>(null);
	const [showFeatureGating, setShowFeatureGating] = useState<boolean>(false);

	const currentReseller = useAppSelector(getResellerData);
	const [autoScaleEnabled, setAutoScaleEnabled] = useState<boolean>(
		currentReseller?.auto_scale_receptionists || false,
	);

	const [isAutoScaleUpdating, setIsAutoScaleUpdating] = useState(false);

	const [showAutoScale, setShowAutoScale] = useState<boolean>(false);
	const [isTutorialsModalOpen, setIsTutorialsModalOpen] = useState(false);

	const [cancelSubscriptionWarningModal, setCancelSubscriptionWarningModal] = useState(false);
	const [endTrialWarningModal, setEndTrialWarningModal] = useState(false);
	const [defaultRegisterPageLoading, setDefaultRegisterPageLoading] = useState(false);

	const [integrationModalVisible, setIntegrationModalVisible] = useState(false);
	const [integrationForm] = Form.useForm();
	const [businessTypeOther, setBusinessTypeOther] = useState(false);

	const integrationRequestMutation = useMutation({
		mutationFn: (payload: any) => requestIntegration(payload, 'Reseller'),
		onSuccess: () => {
			notification.success({
				message: 'Integration Request Submitted',
				description:
					'Your integration request has been received. Our team will contact you shortly.',
			});
			setIntegrationModalVisible(false);
			integrationForm.resetFields();
		},
		onError: (error) => {
			console.error('Integration request error:', error);
			notification.error({
				message: 'Submission Failed',
				description: 'There was an error submitting your request. Please try again.',
			});
		},
	});

	const handleIntegrationSubmit = async (values: any) => {
		const payload = {
			...values,
			username: currentReseller?.emailAddress || values.name,
		};

		integrationRequestMutation.mutate(payload);
	};

	const assignedCsmMember =
		CSM_MEMBERS.find((member) => member.email === resellerData?.csm) || CSM_MEMBERS[0];

	const receptionistTourRef1 = useRef<HTMLDivElement>(null);
	const receptionistTourRef2 = useRef<HTMLDivElement>(null);
	const receptionistTourRef3 = useRef<HTMLDivElement>(null);
	const receptionistTourRef4 = useRef<HTMLDivElement>(null);
	const receptionistTourRef5 = useRef<HTMLDivElement>(null);

	const receptionistTourSteps: TourStepProps[] = [
		{
			title: <h1 className="font-bold text-2xl">Add a receptionist for a Client</h1>,
			description: (
				<p className="text-base">
					This is where you'll manage client onboarding—either by registering them directly, sharing
					the login/signup link, or duplicating existing setups for similar use cases.
				</p>
			),
			target: receptionistTourRef1.current as HTMLElement,
		},
		{
			title: <h1 className="font-bold text-2xl">Manage Your Configured Accounts</h1>,
			description: (
				<p className="text-base">
					View, edit, and manage all your client accounts here. To adjust their settings, just click
					the gear icon.
				</p>
			),
			target: receptionistTourRef2.current as HTMLElement,
		},
		{
			title: <h1 className="font-bold text-2xl">Create trial accounts for your clients</h1>,
			description: (
				<p className="text-base">
					Easily create trial accounts—just like paid ones. Each comes with 15 free test calls, and
					you can create as many as you need.
				</p>
			),
			target: receptionistTourRef3.current as HTMLElement,
		},
		{
			title: <h1 className="font-bold text-2xl">We reward successful partners</h1>,
			description: (
				<p className="text-base">
					Scale with us and unlock exclusive perks as you grow within the program.
				</p>
			),
			target: receptionistTourRef4.current as HTMLElement,
		},
		{
			title: <h1 className="font-bold text-2xl">Your own dedicated Customer Success Manager</h1>,
			description: (
				<p className="text-base">
					From day one, you'll be paired with a dedicated CSM as part of our priority support.
					They're your go-to for anything you need.
				</p>
			),
			target: receptionistTourRef5.current as HTMLElement,
			placement: 'left',
		},
	];

	const updateTutorialMutation = useMutation({
		mutationFn: updateTutorialStepStatus,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['reseller'] });
		},
	});

	const updateToursMutation = useMutation({
		mutationFn: updateTourStatus,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['reseller'] });
		},
	});

	const updateAutoScaleReceptionistMutation = useMutation({
		mutationKey: ['UpdateAutoScaleReceptionist'],
		mutationFn: (newAutoScaleValue: boolean) =>
			UpdateAutoScaleReceptionist({
				reseller_email: resellerData?.emailAddress as string,
				auto_scale: newAutoScaleValue,
				customerId: resellerData?.customerId,
			}),
	});

	const handleAutoScaleChange = (checked: boolean) => {
		setIsAutoScaleUpdating(true);
		setAutoScaleEnabled(checked);
		dispatch(updateReseller({ auto_scale_receptionists: checked }));
		updateAutoScaleReceptionistMutation.mutate(checked, {
			onSuccess: () => {
				setIsAutoScaleUpdating(false);
				notification.success({
					message: 'Auto scale updated',
					duration: 3,
				});
			},
			onError: () => {
				setIsAutoScaleUpdating(false);
				setAutoScaleEnabled(!checked); // Revert the switch if API fails
				dispatch(updateReseller({ auto_scale_receptionists: !checked }));
				notification.error({
					message: 'Failed to update auto scale setting',
				});
			},
		});
	};

	const menu = () => (
		<Menu className="w-[250px]">
			{/* Action Item: Configure */}
			<Menu.Item key="1" icon={<PlusCircleOutlined />} onClick={showAccountModal}>
				Configure Account
			</Menu.Item>

			{/* Action Item: Delete with Popconfirm */}
			<Menu.Item
				key="2"
				icon={<DeleteOutlined />}
				danger
				onClick={() => setRemoveSubscriptiontNoticeModal(true)}
			>
				Delete Receptionist
			</Menu.Item>
		</Menu>
	);

	const showAccountModal = () => {
		setAccountModal(true);
	};

	const cancelAccountModal = () => {
		setAccountModal(false);
	};

	const cancelTrialAccountModal = () => {
		setTrialAccountModal(false);
	};

	const [downloadModalVisible, setDownloadModalVisible] = useState(false);
	const [selectedClientId, setSelectedClientId] = useState<string | null>(null);

	const { data: linkData } = useQuery({
		queryKey: ['getResellerDashboardLink', resellerData?.id],
		queryFn: () => ResellerDashboardLink(),
	});

	const getClientsMutation = useGetResellerClients({
		shouldFetchReservedNumbers: true,
		onSuccess: (data) => {
			setClients(
				data.items.filter(
					(client: any) => client?.accountInfo?.inboundSubscriptionStatus !== 'trialing',
				),
			);
			if (!resellerData?.totalInboundAgents) {
				setSeatsBuyed(5);
			}
			setTrialClients(
				data.items.filter(
					(client: any) => client?.accountInfo?.inboundSubscriptionStatus === 'trialing',
				),
			);

			const createPaidClientModal = searchParams.get('create-paid-client-modal');
			const createTrialClientModal = searchParams.get('create-trial-client-modal');

			if (!createPaidClientModal && !createTrialClientModal) {
				return;
			}

			if (createPaidClientModal === 'true') {
				// Check if seats limit is reached
				if (
					Number(data.items?.length) >=
					Number(resellerData?.unConfiguredInboundAgents + resellerData?.configuredInboundAgents)
				) {
					setNoSeatsAvailableModal(true);
				} else {
					setIsRegistrationModalActive(true);
					setRegistrationType('paid');
					setShowFeatureGating(false);
					setShowAutoScale(false);
				}
				searchParams.delete('create-paid-client-modal');
				setSearchParams(searchParams);
			} else if (createTrialClientModal === 'true') {
				setIsRegistrationModalActive(true);
				setRegistrationType('trial');
				setShowFeatureGating(false);
				setShowAutoScale(false);
				searchParams.delete('create-trial-client-modal');
				setSearchParams(searchParams);
			}
		},
	});

	useEffect(() => {
		if (clients?.length) {
			setMinutesLimitEnabled((prev) => {
				if (prev) {
					return prev;
				}
				return (
					clients.find((client) => client.number === receptionistCurrentlySelected?.number)
						?.minutesLimitEnabled || false
				);
			});
		}
	}, [clients]);

	const getTestClientsMutation = useMutation({
		mutationKey: ['fetchResellerTestClients'],
		mutationFn: fetchResellerTestClients,
		onSuccess(data: any) {
			setSandBoxClients(data.items);
		},
		onError() {},
	});

	const stripeSubscriptionUpdateMutation = useMutation({
		mutationFn: stripeCancelOrUpdate,
		onSuccess: (data) => {
			if (data.status === 'success') {
				window.location.href = data.redirectPaymentURL;
			} else {
				notification.error({ message: 'Failed to cancel subscription' });
			}
		},
		onError: () => {
			notification.error({ message: 'An error occurred while cancelling the subscription' });
		},
	});

	const endTrialMutation = useMutation({
		mutationFn: endTrial,
		onSuccess: () => {
			notification.success({ message: 'Trial ended successfully' });
			dispatch(setTrialStatus(false));
		},
	});

	const handleUpdatePaymentMethodConfirm = () => {
		setCancelSubscriptionWarningModal(true);
	};

	const handleEndTrial = () => {
		setEndTrialWarningModal(true);
	};

	const handleCopyIframe = async (route: string) => {
		if (linkData?.link) {
			try {
				const iframeUrl = `${import.meta.env.VITE_APP_WIHTELABEL_URL}${route}?code=${linkData.link}`;
				const iframeString = `<iframe src="${iframeUrl}" width="100%" height="100%" frameBorder="0" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        zIndex: 999999,
      }}></iframe>`;

				await navigator.clipboard.writeText(iframeString);
				notification.success({ message: 'iframe copied successfully' });
			} catch {
				notification.error({ message: 'Failed to copy iframe' });
			}
		} else {
			notification.error({ message: 'No link available to copy' });
		}
	};

	// Copy the embed link
	const handleTrialCopyIframe = async () => {
		if (linkData?.link) {
			try {
				const iframeUrl = `${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_CLIENT_TRIAL}?code=${linkData.link}`;
				const iframeString = `<iframe src="${iframeUrl}" width="100%" height="100%" frameBorder="0" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          zIndex: 999999,
        }}></iframe>`;

				await navigator.clipboard.writeText(iframeString);
				notification.success({ message: 'iframe copied successfully' });
			} catch {
				notification.error({ message: 'Failed to copy iframe' });
			}
		} else {
			notification.error({ message: 'No link available to copy' });
		}
	};

	const decrementUnreservedReceptionistMutation = useMutation({
		mutationKey: ['decrementUnreservedReceptionist'],
		mutationFn: decrementUnreservedReceptionist,
		onSuccess() {
			dispatch(
				updateReseller({
					...resellerData,
					unConfiguredInboundAgents: resellerData?.unConfiguredInboundAgents - 1,
					totalInboundAgents: resellerData?.totalInboundAgents - 1,
				}),
			);
			setRemoveSubscriptiontNoticeModal(false);

			notification.success({
				message: 'You have successfully deleted unconfigured receptionist',
			});
		},
		onError(error) {
			setRemoveSubscriptiontNoticeModal(false);

			notification.error({
				message: error.message || 'Error deleting receptionist',
			});
		},
	});

	const deleteReceptionistMutation = useMutation({
		mutationKey: ['deleteReceptionist'],
		mutationFn: deleteReceptionist,

		onSuccess(_, payload) {
			setDeleteReceptionistNoticeModal(false);
			setClients((prev) => {
				const newState = prev.filter((client) => client.number !== payload.receptionist_username);
				dispatch(updateResellerClients(newState));
				return newState;
			});
			dispatch(
				updateReseller({
					...resellerData,
					unConfiguredInboundAgents: resellerData?.unConfiguredInboundAgents + 1,
					configuredInboundAgents: resellerData?.configuredInboundAgents - 1,
				}),
			);
			notification.success({
				message: 'Receptionist deleted',
			});
		},
		onError() {
			notification.error({
				message: 'Error deleting receptionist',
			});
		},
	});

	const previewCurrentClientMutation = useMutation({
		mutationKey: ['previewCurrentClient'],
		mutationFn: manageSubAccount,
		onSuccess(client) {
			const smbDashboardLink = window.location.href.replace('/reseller_portal', '/');

			if (client.data?.dashboardLanguage && client.data?.dashboardLanguage !== 'en') {
				LocalStorageUtility.setLocalData(LocalStorageKeys.AUTH_TOKEN, client.token);

				// using form to open in new tab as window.open(smbDashboardLink, '_blank'); sometimes immediately closes the new tab
				const form = document.createElement('form');
				form.method = 'GET';
				form.action = smbDashboardLink;
				form.target = '_blank';
				form.style.display = 'none';

				document.body.appendChild(form);
				form.submit();
				document.body.removeChild(form);

				return;
			}

			if (client.token) {
				dispatch(
					setAccount({
						isAuthenticated: true,
						userAccount: client?.data as UserAccount,
						user: client?.agent as TypeUser,
						selectedAgentId: client?.agent?.number as string,
						authToken: client.token as string,
						currentPage: '' as string,
						activeConfigureTab: '' as string,
						agents: [],
						agentPreview: false,
						crmGroups: null,
					}),
				);

				LocalStorageUtility.setLocalData(LocalStorageKeys.AUTH_TOKEN, client.token);
			}
			setPreviewDashboardModalIsOpen(true);
		},
		onError() {
			notification.error({
				message: 'Error previewing client',
			});
		},
	});

	const updateMangedReceptionistPassword = useMutation({
		mutationKey: ['updateMangedReceptionistPassword'],
		mutationFn: updateManagedReceptionist,
		onSuccess(_, payload) {
			notification.success({
				message: 'Receptionist password updated',
			});

			setClients((prev) => {
				const newState = prev.map((client) => {
					if (client.number === payload.receptionist_username) {
						return {
							...client,
							password: newPassword,
						};
					}
					return client;
				});
				dispatch(updateResellerClients(newState));
				return newState;
			});
			setChangeMangedReceptionistPasswordModal(false);
		},
		onError() {
			notification.error({
				message: 'Error updating receptionist password',
			});
		},
	});

	const updateMangedReceptionistMinutes = useMutation({
		mutationKey: ['updateMangedReceptionistMinutes'],
		mutationFn: updateManagedReceptionist,
		onSuccess(_, payload) {
			notification.success({
				message: 'Receptionist Minutes updated',
			});

			setClients((prev) => {
				const newState = prev.map((client) => {
					if (client.number === payload.receptionist_username) {
						return {
							...client,
							max_minutes: maxMinutes,
							minutesLimitEnabled,
						};
					}
					return client;
				});
				dispatch(updateResellerClients(newState));
				return newState;
			});

			setResellerMinutesLimitationModal(false);
		},
		onError() {
			notification.error({
				message: 'Error updating receptionist minutes',
			});
		},
	});

	const clearAllLogsMutation = useMutation({
		mutationKey: ['clearAllLogs'],
		mutationFn: cleanDataOfManagedReceptionist,
		onSuccess() {
			notification.success({
				message: `Logs cleared for ${receptionistCurrentlySelected?.accountInfo?.username}`,
			});
		},
		onError() {
			notification.error({
				message: 'Error clearing logs',
			});
		},
	});

	const createCheckoutSessionNewResellersMutation = useMutation({
		mutationKey: ['createCheckoutSessionNewResellers'],
		mutationFn: createCheckoutSessionNewResellers,
		onSuccess(data: any) {
			setPurchaseSeatsModal(false);
			if (data?.redirectPaymentURL) {
				window.location.href = data?.redirectPaymentURL;
				notification.success({
					message: 'Payment page opened',
				});
				window.gtag('event', 'resellerPurchaseClicked', {
					event_category: 'EditDemo.js',
					event_label: 'success',
				});
			} else if (data.quantity) {
				dispatch(
					updateReseller({
						...resellerData,
						totalInboundAgents: resellerData?.totalInboundAgents + data.quantity,
						unConfiguredInboundAgents: resellerData?.unConfiguredInboundAgents + data.quantity,
					}),
				);

				if (isResellerOnTrial) {
					endTrialMutation.mutate(resellerData?.inboundSubscriptionId as string);
				}

				notification.success({
					message: `Seats Added to your subscription ${data.quantity}`,
				});
			}
		},
		onError(error) {
			const errorMessage = error?.message || 'Error creating checkout session';
			notification.error({
				message: errorMessage,
			});
			window.gtag('event', 'couldntPurchase', {
				event_category: 'EditDemo.js',
				event_label: 'error',
			});
		},
	});

	const createCopiedReceptionistMutation = useMutation({
		mutationKey: ['createCopiedReceptionist'],
		mutationFn: copySubAccount,
		onSuccess(data) {
			if (!data.success) {
				notification.error({
					message: 'Error copying receptionist',
				});
				return;
			}
			setCopyReceptionistModal(false);
			notification.success({
				message: 'Receptionist copied',
			});
			dispatch(
				updateReseller({
					...resellerData,
					unConfiguredInboundAgents: (resellerData?.unConfiguredInboundAgents as number) - 1,
					configuredInboundAgents: (resellerData?.configuredInboundAgents as number) + 1,
				}),
			);
			getClientsMutation.mutate();
		},
		onError(err) {
			notification.error({
				message: err.message || 'Error copying receptionist',
			});
		},
	});

	const handleCopyReceptionist = () => {
		createCopiedReceptionistMutation.mutate({
			agentId: receptionistCurrentlySelected?.number as string,
			emailAddress: copiedReceptiontCreds.email,
			username: copiedReceptiontCreds.username,
			password: copiedReceptiontCreds.password,
			businessName: copiedReceptiontCreds.businessName,
		});
	};

	const resellerTour = useAppSelector(getResellerTourState);

	React.useEffect(() => {
		if (resellerData?.emailAddress) {
			getClientsMutation.mutate();
		}
	}, [resellerData?.emailAddress]);

	useEffect(() => {
		if (!resellerData?.emailAddress || resellerTour.open) {
			return;
		}

		const createPaidClientModal = searchParams.get('create-paid-client-modal');
		const createTrialClientModal = searchParams.get('create-trial-client-modal');

		if (
			resellerData?.tours?.receptionist ||
			createPaidClientModal ||
			createTrialClientModal ||
			isRegistrationModalActive
		) {
			return;
		}

		updateToursMutation.mutate('receptionist');
		dispatch(
			setTour({
				open: true,
				currentStep: 0,
				returnTo: AppRoutes.RESELLER_PORTAL,
			}),
		);
	}, [resellerData?.emailAddress, resellerTour.open, isRegistrationModalActive]);

	useEffect(() => {
		window.gtag('event', 'WhitelabelReceptionistDirectoryView', {
			event_category: 'Pageview',
		});
	}, []);

	const isClientOnTrialMutation = useMutation({
		mutationKey: ['is-client-on-trial'],
		mutationFn: () => currentSubscriptionInformation('Reseller'),
		onSuccess: (data) => {
			dispatch(setTrialStatus(!!data.data?.allowExtendTrial));
		},
		onError: () => {
			dispatch(setTrialStatus(false));
		},
	});

	React.useEffect(() => {
		isClientOnTrialMutation.mutate();
		if (resellerData?.emailAddress) {
			getTestClientsMutation.mutate();
		}
	}, [resellerData?.inboundSubscriptionId, resellerData?.emailAddress]);

	// getTwilioBundleStatus get call using useQuery with bundleId as a parameter

	const { data } = useQuery({
		queryKey: ['getTwilioBundleStatus', resellerData?.twilioBundleId],
		queryFn: () => getTwilioBundleStatus(resellerData?.twilioBundleId as string, true),
		enabled: !!resellerData?.twilioBundleId,
		staleTime: 5 * 60 * 1000, // Cache for 5 minutes
		retry: 3,
	});

	useEffect(() => {
		if (data) {
			dispatch(updateReseller({ twilioBundleStatus: data.status }));
		}
	}, [data]);

	const handleOpenDownloadModal = (clientId: string) => {
		setSelectedClientId(clientId);
		setDownloadModalVisible(true);
	};

	const handleOpenManageCreditModal = ({
		subAccountId,
		clientSubscribedProductId,
		clientSubscriptionStatus,
		username,
	}: {
		subAccountId: string;
		clientSubscribedProductId?: string;
		clientSubscriptionStatus?: string;
		username: string;
	}) => {
		queryClient.invalidateQueries({
			queryKey: ['getUserCredits', subAccountId],
		});
		dispatch(
			openModal({
				modalId: MODAL_IDS.RESELLER_MANAGE_CREDITS,
				data: { subAccountId, clientSubscribedProductId, clientSubscriptionStatus, username },
			}),
		);
	};

	const handleCloseDownloadModal = () => {
		setSelectedClientId(null);
		setDownloadModalVisible(false);
	};

	const handleConvertTrial = (number: string) => {
		onConvertTrialClient.mutate({
			reseller_email: resellerData?.emailAddress as string,
			agentId: number,
		});
	};

	const onConvertTrialClient = useMutation({
		mutationKey: ['convertTrialClient'],
		mutationFn: convertTrialReceptionist,
		onSuccess(_, payload) {
			// Find the client in sandBoxClients before removing it
			const convertedClient = sandBoxClients.find((client) => client.number === payload.agentId);

			// Remove from trial clients
			setSandBoxClients((prev) => prev.filter((client) => client.number !== payload.agentId));

			// Add to main clients with demo set to false
			if (convertedClient) {
				setClients((prev) => [...prev, { ...convertedClient, demo: false }]);
			}

			if (resellerData?.unConfiguredInboundAgents > 0) {
				dispatch(
					updateReseller({
						...resellerData,
						unConfiguredInboundAgents: resellerData?.unConfiguredInboundAgents - 1,
						configuredInboundAgents: resellerData?.configuredInboundAgents + 1,
					}),
				);
			}

			notification.success({
				message: 'Client converted to full account',
			});

			// Reset the currentClient state to stop the loading indicator
			setCurrentReceptionist(null);
		},
		onError() {
			notification.error({
				message: 'Error converting client',
			});
		},
	});

	const { data: subscriptionUnitPrice } = useQuery({
		queryKey: ['getSubscriptionUnitPrice'],
		queryFn: getSubscriptionUnitPrice,
	});

	const [embedType, setEmbedType] = useState<'login' | 'register' | null>(null);

	const handleTutorialClick = () => {
		if (!resellerData?.tutorial_steps?.receptionist_tutorial) {
			updateTutorialMutation.mutate('receptionist_tutorial');
		}
		setIsTutorialsModalOpen(true);
	};

	const handleTourClick = () => {
		setIsTutorialsModalOpen(false);

		if (!resellerData?.tours?.receptionist) {
			updateToursMutation.mutate('receptionist');
		}
	};

	const [showClientDetailsModal, setShowClientDetailsModal] = useState(false);
	const [selectedClientDetails, setSelectedClientDetails] = useState<{
		number: string;
		email_address: string;
		testing_number: string;
		businessType: string;
		accountInfo: UserAccount;
	} | null>(null);

	const handleShowClientDetails = (client: any) => {
		setSelectedClientDetails({
			number: client.number,
			email_address: client.email_address,
			testing_number: client.testing_number,
			businessType: client.businessType,
			accountInfo: client.accountInfo,
		});
		setShowClientDetailsModal(true);
	};

	useEffect(() => {
		setAutoScaleEnabled(currentReseller?.auto_scale_receptionists);
	}, [currentReseller?.auto_scale_receptionists]);

	const { mutate: updateDefaultRegistrationMutation, isPending } = useMutation({
		mutationKey: ['updateDefaultRegistration'],
		mutationFn: updateDefaultRegistration,
		onSuccess: (data) => {
			notification.success({ message: data.message });
			setDefaultRegisterPageLoading(false);
		},
		onError: () => {
			notification.error({
				message: 'Error',
				description: 'An error occurred while updating the domain. Please try again!',
			});
		},
	});

	return (
		<ResellerDashboard activeKey={ResellerSiderItem.MY_RECEPTIONISTS}>
			<FeatureGatingCustomizeModal setClients={(data) => setClients(data)} clients={clients} />

			{!resellerData || getClientsMutation.isPending ? (
				<Loading />
			) : (
				<div className="p-8">
					{isResellerOnTrial && (
						<div className="bg-blue-50 p-4 mb-4 flex justify-between items-center">
							<div>
								<Text strong className="text-blue-700">
									Trial Account
								</Text>
								<Text className="ml-2 text-blue-600">
									You are currently on a trial subscription.
								</Text>
							</div>
							<div className="space-x-4">
								<Button
									danger
									onClick={handleUpdatePaymentMethodConfirm}
									loading={stripeSubscriptionUpdateMutation.isPending}
								>
									Cancel Subscription
								</Button>
								<Button
									type="primary"
									onClick={handleEndTrial}
									loading={endTrialMutation.isPending}
								>
									End Trial Now
								</Button>
							</div>
						</div>
					)}

					<div className="flex flex-col md:flex-row md:justify-between items-center">
						<h1 className="text-xl font-semibold my-2 md:my-0">All Receptionists</h1>
						<Button
							type="default"
							onClick={handleTutorialClick}
							className={
								!resellerData?.tutorial_steps?.receptionist_tutorial
									? 'bg-[#F1F8FF] hover:bg-[#F1F8FF] text-blue-600 has-ping overflow-hidden w-full sm:w-auto'
									: 'w-full sm:w-auto'
							}
						>
							<BookOpenIcon size={16} />
							<span>Tutorials</span>
						</Button>
					</div>

					<Row gutter={16} className="mt-4">
						<Col xl={16} lg={16} md={16} sm={24} xs={24}>
							<div ref={receptionistTourRef1} className="card p-3 bg-white rounded-lg mt-3">
								<h3 className="text-lg font-semibold mb-2">Quick Actions</h3>
								<Row gutter={[12, 12]} className="w-full">
									<Col xs={24} sm={24} md={24} lg={24} xl={24}>
										<button onClick={showAccountModal} className="w-full text-left h-full">
											<div className="p-3 border-2 rounded-lg h-full flex flex-col">
												<div className="flex items-start">
													<AddCircleOutlineOutlined className="text-blue-600 mt-1" />
													<div className="ml-2">
														<h3 className="my-0 text-base font-semibold">Add New Client</h3>
														<p className="my-0 text-gray-400">
															Setup a new business account. Choose between trial or paid
															registration.
														</p>
													</div>
												</div>
											</div>
										</button>
									</Col>
								</Row>
							</div>

							<div ref={receptionistTourRef2} className="card p-3 bg-white rounded-lg mt-3">
								<h3 className="text-lg font-semibold mb-0">
									Active Clients ({clients?.length}
									{resellerData?.unlimitedInboundAgents
										? ' / ∞'
										: '/' +
											Number(
												resellerData?.unConfiguredInboundAgents +
													resellerData?.configuredInboundAgents,
											)}
									)
								</h3>
								<p className="mt-0 text-gray-600 mb-3 text-sm sm:text-base">
									{Number(
										resellerData?.unConfiguredInboundAgents + resellerData?.configuredInboundAgents,
									) === clients?.length
										? 'You have set up all your available seats.'
										: `You have set up ${clients?.length} of ${
												resellerData?.unlimitedInboundAgents
													? 'unlimited'
													: Number(
															resellerData?.unConfiguredInboundAgents +
																resellerData?.configuredInboundAgents,
														)
											} accounts. Adding a new account will not increase your monthly charge, since you are paying for ${
												resellerData?.unlimitedInboundAgents
													? 'unlimited'
													: Number(
															resellerData?.unConfiguredInboundAgents +
																resellerData?.configuredInboundAgents,
														)
											}.`}
								</p>
								<ClientList
									clients={clients}
									setCurrentReceptionist={setCurrentReceptionist}
									setDeleteReceptionistNoticeModal={setDeleteReceptionistNoticeModal}
									setChangeMangedReceptionistPasswordModal={
										setChangeMangedReceptionistPasswordModal
									}
									setClearAllLogsWarningModal={setClearAllLogsWarningModal}
									setResellerMinutesLimitationModal={setResellerMinutesLimitationModal}
									previewCurrentClientMutation={previewCurrentClientMutation}
									currentClient={receptionistCurrentlySelected}
									setCurrentClient={setCurrentReceptionist}
									handleOpenDownloadModal={handleOpenDownloadModal}
									handleOpenManageCreditModal={handleOpenManageCreditModal}
									isTrial={false}
									onShowClientDetails={handleShowClientDetails}
								/>
							</div>

							{resellerData?.stripe_connect_id && (
								<div className="card p-3 bg-white rounded-lg mt-3">
									<h3 className="text-lg font-semibold mb-3">
										Trial Accounts ({trialClients?.length || 0} / ∞)
									</h3>
									{trialClients && trialClients.length > 0 ? (
										<ClientList
											clients={trialClients}
											setCurrentReceptionist={setCurrentReceptionist}
											setDeleteReceptionistNoticeModal={setDeleteReceptionistNoticeModal}
											setChangeMangedReceptionistPasswordModal={
												setChangeMangedReceptionistPasswordModal
											}
											setClearAllLogsWarningModal={setClearAllLogsWarningModal}
											setResellerMinutesLimitationModal={setResellerMinutesLimitationModal}
											previewCurrentClientMutation={previewCurrentClientMutation}
											currentClient={receptionistCurrentlySelected}
											setCurrentClient={setCurrentReceptionist}
											handleOpenDownloadModal={handleOpenDownloadModal}
											handleOpenManageCreditModal={handleOpenManageCreditModal}
											isTrial={false}
											onConvert={handleConvertTrial}
											onShowClientDetails={handleShowClientDetails}
										/>
									) : (
										<p className="text-gray-500">No trial accounts yet.</p>
									)}
								</div>
							)}

							<div ref={receptionistTourRef3} className="card p-3 bg-white rounded-lg mt-3">
								<h3 className="text-lg font-semibold mb-3">
									Sandbox Accounts ({sandBoxClients?.length || 0} / ∞)
								</h3>
								{sandBoxClients && sandBoxClients.length > 0 ? (
									<ClientList
										clients={sandBoxClients}
										setCurrentReceptionist={setCurrentReceptionist}
										setDeleteReceptionistNoticeModal={setDeleteReceptionistNoticeModal}
										setChangeMangedReceptionistPasswordModal={
											setChangeMangedReceptionistPasswordModal
										}
										setClearAllLogsWarningModal={setClearAllLogsWarningModal}
										setResellerMinutesLimitationModal={setResellerMinutesLimitationModal}
										previewCurrentClientMutation={previewCurrentClientMutation}
										currentClient={receptionistCurrentlySelected}
										setCurrentClient={setCurrentReceptionist}
										handleOpenDownloadModal={handleOpenDownloadModal}
										handleOpenManageCreditModal={handleOpenManageCreditModal}
										isTrial={true}
										onConvert={handleConvertTrial}
										onShowClientDetails={handleShowClientDetails}
									/>
								) : (
									<p className="text-gray-500">No trial accounts yet.</p>
								)}
							</div>

							{resellerData?.unlimitedInboundAgents ? null : (
								<div className="card p-3 bg-white rounded-lg mt-3">
									<h3 className="text-lg font-semibold mb-3">
										Unconfigured Accounts ({resellerData?.unConfiguredInboundAgents || 0} /{' '}
										{Number(
											resellerData?.unConfiguredInboundAgents +
												resellerData?.configuredInboundAgents,
										)}
										)
									</h3>

									{resellerData?.unConfiguredInboundAgents &&
									resellerData?.unConfiguredInboundAgents > 0 ? (
										<Row gutter={[12, 12]} className="mt-2">
											{Array.from({ length: resellerData?.unConfiguredInboundAgents || 0 }).map(
												(_, i) => (
													<Col xs={24} sm={24} md={12} lg={12} xl={12} key={i}>
														<div className="bg-gray-100 p-4 rounded-lg flex items-center justify-between h-full">
															<div className="overflow-hidden max-w-[75%]">
																<h3 className="font-semibold text-lg my-0 text-ellipsis overflow-hidden whitespace-nowrap">
																	Receptionist Slot ({i + 1})
																</h3>
																<p className="text-sm text-gray-600 m-0">Not yet configured</p>
															</div>
															<div className="flex items-center">
																<Dropdown overlay={menu()} trigger={['click']}>
																	<Button icon={<SettingOutlined />} />
																</Dropdown>
															</div>
														</div>
													</Col>
												),
											)}
										</Row>
									) : (
										<p className="text-gray-500">No unconfigured receptionist slots available.</p>
									)}
								</div>
							)}
						</Col>

						<Col xl={8} lg={8} md={8} sm={24} xs={24}>
							<div ref={receptionistTourRef5} className="h-fit">
								<CsmCard
									avatarUrl={assignedCsmMember.imageUrl || ''}
									name={assignedCsmMember.name || 'N/A'}
									email={assignedCsmMember.email || 'N/A'}
									description="As your Customer Success Manager, I'm here to help you get the most out of our platform. Feel free to book a call with me to discuss any questions or concerns you may have."
									calendlyLink={assignedCsmMember.calendlyLink}
									className="card"
								/>
							</div>
						</Col>
					</Row>

					<Modal
						title="Request an Integration"
						open={integrationModalVisible}
						onCancel={() => setIntegrationModalVisible(false)}
						footer={null}
						maskClosable={false}
						destroyOnClose
					>
						<p className="text-gray-500 mb-4">
							Need integrations with your favorite tools and services? <br />
							Send us your request, and our team will review it and reach out to discuss the
							details.
						</p>
						<Form form={integrationForm} layout="vertical" onFinish={handleIntegrationSubmit}>
							<Form.Item
								name="name"
								label="Your name"
								rules={[{ required: true, message: 'Please enter your name' }]}
							>
								<Input placeholder="Please enter your name" />
							</Form.Item>

							<Form.Item
								name="businessType"
								label="Business Type"
								rules={[{ required: true, message: 'Please select your business type' }]}
							>
								<Select
									placeholder="Select your business type"
									onChange={(value) => setBusinessTypeOther(value.toLowerCase() === 'other')}
								>
									{businessTypes.map((item, index) => (
										<Option key={index} value={item.toLowerCase()}>
											{item}
										</Option>
									))}
								</Select>
							</Form.Item>

							{businessTypeOther && (
								<Form.Item
									name="businessTypeOther"
									label="Specify Business Type"
									rules={[{ required: true, message: 'Please specify your business type' }]}
								>
									<Input placeholder="Please specify your business type" />
								</Form.Item>
							)}

							<Form.Item
								name="businessName"
								label="Your business name"
								rules={[{ required: true, message: 'Please enter your business name' }]}
							>
								<Input placeholder="Please enter your business name" />
							</Form.Item>

							<Form.Item
								name="revenue"
								label="Annual Revenue"
								rules={[{ required: true, message: 'Please enter your annual revenue' }]}
							>
								<Select placeholder="Select revenue range">
									{revenueRanges.map((range, index) => (
										<Option key={index} value={range.value}>
											{range.label}
										</Option>
									))}
								</Select>
							</Form.Item>

							<Form.Item
								name="requestedIntegration"
								label="Requested Integration"
								rules={[{ required: true, message: 'Please describe the integration you need' }]}
							>
								<TextArea
									rows={4}
									placeholder="Please describe the integration you need and how it would help your business"
								/>
							</Form.Item>

							<div className="flex justify-end gap-2 mt-4">
								<Button onClick={() => setIntegrationModalVisible(false)}>Cancel</Button>
								<Button
									type="primary"
									htmlType="submit"
									loading={integrationRequestMutation.isPending}
								>
									Submit Request
								</Button>
							</div>
						</Form>
					</Modal>

					{/* Account Modal */}
					<Modal open={accountModal} footer={null} onCancel={cancelAccountModal}>
						<h3 className="mb-4 font-semibold text-xl">Add New Client</h3>
						<a
							onClick={() => {
								setAccountModal(false);
								setRegistrationType(null);
								setShowFeatureGating(false);
								setShowAutoScale(false);
								setIsRegistrationModalActive(true);
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<AddCircleOutlineOutlined className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Add Client Directly</h4>
								<p className="my-0 text-gray-600 text-sm">
									Add client manually through your dashboard
								</p>
							</div>
						</a>

						<a
							onClick={() => {
								if (
									Number(clients?.length) >=
									Number(
										resellerData?.unConfiguredInboundAgents + resellerData?.configuredInboundAgents,
									)
								) {
									setNoSeatsAvailableModal(true);
								} else {
									setAccountModal(false);
									setCopyReceptionistModal(true);
								}
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<CopyAll className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Copy Existing Receptionist</h4>
								<p className="my-0 text-gray-600 text-sm">
									Copy all configuration from existing client
								</p>
							</div>
						</a>

						<a
							onClick={() => {
								setAccountModal(false);
								setEmbedRegisterOptionsModal(true);
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<Globe className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Website Integration</h4>
								<p className="my-0 text-gray-600 text-sm">
									Let clients sign up through your website
								</p>
							</div>
						</a>
					</Modal>

					{/* Trial Account Modal */}
					<Modal open={trialAccountModal} footer={null} onCancel={cancelTrialAccountModal}>
						<h3 className="mb-4 font-semibold text-xl">Add New Client</h3>
						<a
							onClick={() => {
								setTrialAccountModal(false);
								setIsRegistrationModalActive(true);
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<AddCircleOutlineOutlined className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Add Client Directly</h4>
								<p className="my-0 text-gray-600 text-sm">
									Add client manually through your dashboard
								</p>
							</div>
						</a>

						<a
							onClick={() => {
								setTrialAccountModal(false);
								setEmbedTrialLinkModal(true);
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<Globe className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Website Integration</h4>
								<p className="my-0 text-gray-600 text-sm">
									Let clients sign up through your website
								</p>
							</div>
						</a>
					</Modal>

					{/* Embed */}
					<CustomModal
						title={null}
						isModalOpen={embedLinkModal}
						confirmAction={() => {
							setEmbedLinkModal(false);
						}}
						cancelAction={() => {
							setEmbedLinkModal(false);
						}}
					>
						<Title level={4}>Embed iframes for login/register</Title>
						<p className="text-sm">
							Copy the below iframe code and paste it in your website to embed login/register.
						</p>

						<Typography.Text strong>For Login</Typography.Text>

						<Input
							value={`<iframe src=${import.meta.env.VITE_APP_WIHTELABEL_URL + AppRoutes.UNBRANDED_DASHBOARD + '?code=' + linkData?.link} width="100%" height="100%" frameBorder="0"></iframe>`}
							readOnly
							suffix={
								<CopyOutlined
									className="cursor-pointer text-gray-500 hover:text-gray-700"
									onClick={() => handleCopyIframe(AppRoutes.UNBRANDED_DASHBOARD)}
								/>
							}
						/>
						<Typography.Text strong>For Register</Typography.Text>
						<Input
							value={`<iframe src=${import.meta.env.VITE_APP_WIHTELABEL_URL + AppRoutes.GENERIC_DOMAIN_REGISTER + '?code=' + linkData?.link} width="100%" height="100%" frameBorder="0"></iframe>`}
							readOnly
							suffix={
								<CopyOutlined
									className="cursor-pointer text-gray-500 hover:text-gray-700"
									onClick={() => handleCopyIframe(AppRoutes.GENERIC_DOMAIN_REGISTER)}
								/>
							}
						/>
					</CustomModal>

					{/* Embed Trial */}
					<Modal
						open={embedTrialLinkModal}
						footer={null}
						onCancel={() => setEmbedTrialLinkModal(false)}
					>
						<h3 className="mb-4 font-semibold text-xl">Embed Trial Registration</h3>
						<p className="text-sm">
							Copy the below iframe code to embed the trial registration form on your website.
						</p>

						<Input
							value={`<iframe src="${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_CLIENT_TRIAL}?code=${linkData?.link}" width="100%" height="100%" frameBorder="0"></iframe>`}
							readOnly
							suffix={
								<CopyOutlined
									className="cursor-pointer text-gray-500 hover:text-gray-700"
									onClick={() => handleTrialCopyIframe()}
								/>
							}
						/>
						<Text className="mt-2 text-red-600">
							Note: Same Login iframe can be used for both trial and regular users.
						</Text>
					</Modal>

					{/* All Modals below this point */}
					<CustomModal
						title="Success"
						isModalOpen={successConfigureReceptionistModal}
						confirmAction={() => {
							getClientsMutation.mutate();

							setSuccessConfigureReceptionistModal(false);
						}}
						cancelAction={() => {
							getClientsMutation.mutate();
							setSuccessConfigureReceptionistModal(false);
						}}
					>
						<Title level={4}>
							Congrats, your new receptionist has been onboarded successfully!
						</Title>
					</CustomModal>

					<CustomModal
						title="Are you sure?"
						isModalOpen={deleteReceptionistNoticeModal}
						confirmAction={() => {
							if (receptionistCurrentlySelected) {
								deleteReceptionistMutation.mutate({
									receptionist_username: receptionistCurrentlySelected.number,
									reseller_email: resellerData?.emailAddress as string,
								});
							}
						}}
						loading={deleteReceptionistMutation.isPending}
						cancelAction={() => {
							setDeleteReceptionistNoticeModal(false);
						}}
						okText="Yes, Proceed"
					>
						<Title level={4}>
							This action cannot be undone. Are you sure you want to delete this receptionist?
						</Title>
					</CustomModal>

					{previewDashboardModalIsOpen && (
						<CustomModal
							title={null}
							footer={null}
							isModalOpen={previewDashboardModalIsOpen}
							confirmAction={() => {
								setPreviewDashboardModalIsOpen(false);
							}}
							width={'90%'}
							cancelAction={() => {
								setPreviewDashboardModalIsOpen(false);
							}}
							// make close button bigger and more visible
							closeIcon={
								<Button type="text" className="text-2xl bg-red-500 text-white rounded-full p-2">
									<CloseOutlined />
								</Button>
							}
						>
							<ReceptionistDashboard
								debrand={true}
								handleClose={() => {
									setPreviewDashboardModalIsOpen(false);
								}}
							/>
						</CustomModal>
					)}

					<CustomModal
						title={null}
						isModalOpen={changeMangedReceptionistPasswordModal}
						confirmAction={() => {
							if (receptionistCurrentlySelected && newPassword) {
								updateMangedReceptionistPassword.mutate({
									receptionist_username: receptionistCurrentlySelected.number,
									fields: { password: newPassword },
									userId: receptionistCurrentlySelected.accountInfo?.id,
								});
							}
						}}
						cancelAction={() => {
							setChangeMangedReceptionistPasswordModal(false);
						}}
						okText="Change Password"
						okButtonProps={{ danger: true }}
					>
						<Title level={4}>
							Change Password for username {receptionistCurrentlySelected?.accountInfo?.username}
						</Title>
						<Input
							placeholder="New Password"
							onChange={(e) => {
								setNewPassword(e.target.value);
							}}
						/>
					</CustomModal>

					<CustomModal
						title="Are you sure?"
						isModalOpen={clearAllLogsWarningModal}
						confirmAction={() => {
							if (receptionistCurrentlySelected) {
								clearAllLogsMutation.mutate({
									receptionist_username: receptionistCurrentlySelected.number,
									tableNames: ['voicemails', 'textLogs', 'callLogs'],
								});
							}
							setClearAllLogsWarningModal(false);
						}}
						cancelAction={() => {
							setClearAllLogsWarningModal(false);
						}}
						okText="Yes, Proceed"
					>
						<Title level={4}>
							This action cannot be undone. Are you sure you want to clear all logs for{' '}
							{receptionistCurrentlySelected?.accountInfo?.username as string} receptionist?
						</Title>
					</CustomModal>

					<CustomModal
						title="Minutes Limitation"
						isModalOpen={resellerMinutesLimitationModal}
						confirmAction={() => {
							if (receptionistCurrentlySelected) {
								updateMangedReceptionistMinutes.mutate({
									receptionist_username: receptionistCurrentlySelected.number,
									fields: {
										max_minutes: maxMinutes,
										usage_notification_emails: [resellerData?.emailAddress],
										enabled: minutesLimitEnabled,
									},
									userId: receptionistCurrentlySelected.accountInfo?.id,
								});
							}
						}}
						cancelAction={() => {
							setResellerMinutesLimitationModal(false);
						}}
						okText="Save"
					>
						<Title level={4}>
							Set Minutes Limitation for {receptionistCurrentlySelected?.accountInfo?.username}
						</Title>

						<div className="mt-4 space-y-4">
							<div className="flex flex-col">
								<label className="font-medium">Maximum Minutes</label>
								<InputNumber
									min={1}
									value={
										clients.find(
											(client) => client.number === receptionistCurrentlySelected?.number,
										)?.max_minutes || 0
									}
									onChange={(value) => {
										setMaxMinutes(value);
										// update that client from clients array
										const updatedClients = clients.map((client) =>
											client.number === receptionistCurrentlySelected?.number
												? { ...client, max_minutes: value }
												: client,
										);
										setClients(updatedClients);
									}}
									className="w-full mt-2"
								/>
							</div>

							<div className="flex flex-row justify-between items-center">
								<label className="font-medium">Enable Limitation</label>
								<Switch
									checked={minutesLimitEnabled}
									onChange={(checked) => setMinutesLimitEnabled(checked)}
								/>
							</div>
						</div>
					</CustomModal>

					<CustomModal
						title="Purchase More Seats"
						isModalOpen={purchaseSeatsModal}
						confirmAction={() => {
							// Purchase more seats
							if (seatsBuyed) {
								createCheckoutSessionNewResellersMutation.mutate({
									resellerEmail: resellerData?.emailAddress as string,
									quantity: seatsBuyed,
								});
							}
						}}
						cancelAction={() => {
							setPurchaseSeatsModal(false);
						}}
						okText="Purchase"
						loading={createCheckoutSessionNewResellersMutation.isPending}
					>
						<Title level={4}>Buy More seats for your reseller dashboard</Title>

						<Typography.Text>
							You currently have{' '}
							{Number(
								resellerData?.configuredInboundAgents + resellerData?.unConfiguredInboundAgents,
							) || 'no'}{' '}
							seats. How many more would you like to purchase?{' '}
							{Number(
								resellerData?.configuredInboundAgents + resellerData?.unConfiguredInboundAgents,
							)
								? ''
								: 'Note: for newcomers if they are new they must buy  5 seats '}
						</Typography.Text>
						{isResellerOnTrial && (
							<Typography.Text className="text-orange-600 font-semibold">
								Note: Your trial would end immediately after purchasing additional seats.
							</Typography.Text>
						)}

						<div className="mt-4 space-y-4">
							<div className="flex flex-col">
								<label className="font-medium">Number of Seats</label>
								<InputNumber
									min={resellerData?.totalInboundAgents ? 1 : 5}
									value={seatsBuyed}
									className="w-full mt-2"
									onChange={(value) => setSeatsBuyed(value)}
								/>
							</div>
						</div>
						{subscriptionUnitPrice?.unitPrice && (
							<Typography.Text>
								you would get charged{' '}
								<span className="font-semibold">{subscriptionUnitPrice?.unitPrice}$</span> more per
								seat per month
							</Typography.Text>
						)}
					</CustomModal>

					<CustomModal
						title="No Available Seats"
						isModalOpen={noSeatsAvailableModal}
						confirmAction={() => {
							setNoSeatsAvailableModal(false);
							setPurchaseSeatsModal(true);
						}}
						cancelAction={() => {
							setNoSeatsAvailableModal(false);
						}}
						okText="Purchase More Seats"
					>
						<Title level={4}>You've reached your seat limit</Title>
						<Typography.Text>
							You currently have{' '}
							{Number(
								resellerData?.configuredInboundAgents + resellerData?.unConfiguredInboundAgents,
							) || 'no'}{' '}
							seats and all are in use. To create new client accounts, you'll need to purchase
							additional seats.
						</Typography.Text>
						<br />
						{isResellerOnTrial && (
							<Typography.Text className="text-orange-600 font-semibold">
								Note: Your trial would end immediately after purchasing additional seats.
							</Typography.Text>
						)}
						<div className="flex items-center mt-4">
							<ShoppingCartOutlined className="text-blue-600 mr-2" />
							<Typography.Text>
								Click "Purchase More Seats" to expand your capacity.
							</Typography.Text>
							<br />
						</div>
					</CustomModal>

					<CustomModal
						title="Are you sure?"
						isModalOpen={removeSubscriptionModal}
						confirmAction={() => {
							if (
								resellerData?.totalInboundAgents <= (resellerData?.minimumAllowedInboundAgents ?? 5)
							) {
								notification.error({
									message: `You must retain at least ${resellerData?.minimumAllowedInboundAgents || 5} seats`,
								});
								return;
							}
							decrementUnreservedReceptionistMutation.mutate();
						}}
						loading={decrementUnreservedReceptionistMutation.isPending}
						cancelAction={() => {
							setRemoveSubscriptiontNoticeModal(false);
						}}
						okText="Yes, Proceed"
					>
						<Title level={4}>
							This action cannot be undone. Are you sure you want to delete this receptionist?
						</Title>
					</CustomModal>
					<CustomModal
						title="Copy Existing Receptionist"
						isModalOpen={copyReceptionistModal}
						confirmAction={handleCopyReceptionist}
						cancelAction={() => {
							setCopyReceptionistModal(false);
							setCopiedReceptiontCreds({ username: '', password: '', email: '', businessName: '' });
						}}
						okText="Copy Receptionist"
						loading={createCopiedReceptionistMutation.isPending}
					>
						<div className="space-y-4">
							<Title level={4}>Select a receptionist to copy and provide new credentials</Title>

							<div className="flex flex-col space-y-2">
								<label className="font-medium">Select Receptionist to Copy</label>
								<Select
									placeholder="Select a receptionist"
									className="w-full"
									onChange={(value) => {
										setCurrentReceptionist({
											number: value,
											accountInfo: clients?.find((client) => client.number === value)?.accountInfo,
										});
									}}
									value={receptionistCurrentlySelected?.number}
								>
									{clients.map((client) => (
										<Select.Option key={client.number} value={client.number}>
											{client.accountInfo.businessName} ({client?.accountInfo?.username})
										</Select.Option>
									))}
								</Select>
							</div>

							{receptionistCurrentlySelected && (
								<div className="space-y-4 mt-4">
									<div className="flex flex-col space-y-2">
										<label className="font-medium">New Business Name</label>
										<Input
											placeholder="Enter new business name"
											value={copiedReceptiontCreds.businessName}
											onChange={(e) =>
												setCopiedReceptiontCreds((prev) => ({
													...prev,
													businessName: e.target.value,
												}))
											}
										/>
									</div>
									<div className="flex flex-col space-y-2">
										<label className="font-medium">New Email</label>
										<Input
											placeholder="Enter new email"
											value={copiedReceptiontCreds.email}
											onChange={(e) =>
												setCopiedReceptiontCreds((prev) => ({
													...prev,
													email: e.target.value,
												}))
											}
										/>
									</div>

									<div className="flex flex-col space-y-2">
										<label className="font-medium">New Username</label>
										<Input
											placeholder="Enter new username"
											value={copiedReceptiontCreds.username}
											onChange={(e) =>
												setCopiedReceptiontCreds((prev) => ({
													...prev,
													username: e.target.value,
												}))
											}
										/>
									</div>

									<div className="flex flex-col space-y-2">
										<label className="font-medium">New Password</label>
										<Input.Password
											placeholder="Enter new password"
											value={copiedReceptiontCreds.password}
											onChange={(e) =>
												setCopiedReceptiontCreds((prev) => ({
													...prev,
													password: e.target.value,
												}))
											}
										/>
									</div>
								</div>
							)}
						</div>
					</CustomModal>
					{/* Client Type Selection Modal */}
					<Modal
						open={isRegistrationModalActive}
						footer={null}
						onCancel={() => {
							setIsRegistrationModalActive(false);
							setRegistrationType(null);
							setShowFeatureGating(false);
							setShowAutoScale(false);
						}}
						width={!registrationType ? 600 : '90%'} // Dynamic width based on stage
					>
						{!registrationType ? (
							<>
								<h3 className="mb-4 font-semibold text-xl">Choose Client Type</h3>
								<p className="text-sm mb-4">
									Select whether you want to add a trial or paid client.
								</p>

								<a
									onClick={() => {
										if (
											Number(clients?.length) >=
											Number(
												resellerData?.unConfiguredInboundAgents +
													resellerData?.configuredInboundAgents,
											)
										) {
											setNoSeatsAvailableModal(true);
										} else {
											setRegistrationType('paid');
											setShowFeatureGating(false);
											setShowAutoScale(false);
										}
									}}
								>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<Globe className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Paid Client</h4>
										<p className="my-0 text-gray-600 text-sm">
											For clients ready to purchase a subscription
										</p>
									</div>
								</a>

								<a
									onClick={() => {
										setRegistrationType('trial');
										setShowFeatureGating(false);
										setShowAutoScale(false);
									}}
								>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<Globe className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Trial Client</h4>
										<p className="my-0 text-gray-600 text-sm">
											For clients who want to try the service first
										</p>
									</div>
								</a>
							</>
						) : (
							<UserRegistrationPage
								trialForReseller={registrationType === 'trial'}
								debrand
								resellerId={resellerData?.id}
								handleComplete={() => {
									setIsRegistrationModalActive(false);
									setSuccessConfigureReceptionistModal(true);
									if (registrationType === 'trial') {
										getTestClientsMutation.mutate();
									} else {
										dispatch(
											updateReseller({
												...resellerData,
												unConfiguredInboundAgents: resellerData?.unConfiguredInboundAgents - 1,
												configuredInboundAgents: resellerData?.configuredInboundAgents + 1,
											}),
										);
									}
								}}
								agentType={'Inbound'}
							/>
						)}
					</Modal>

					{/* <ManageCreditsModal /> */}

					{selectedClientId && (
						<DownloadCallLogsModal
							isOpen={downloadModalVisible}
							onClose={handleCloseDownloadModal}
							clientId={selectedClientId}
							clientName={
								clients.find((client) => client.number === selectedClientId)?.accountInfo
									?.businessName || 'Client'
							}
						/>
					)}

					{/* Add new Options Modal */}
					<Modal
						open={embedOptionsModal}
						footer={null}
						onCancel={() => setEmbedOptionsModal(false)}
					>
						<h3 className="mb-4 font-semibold text-xl">Website Integration</h3>

						<a
							onClick={() => {
								setEmbedOptionsModal(false);
								setEmbedLoginModal(true);
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<Globe className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Login Form</h4>
								<p className="my-0 text-gray-600 text-sm">
									Embed client login form on your website
								</p>
							</div>
						</a>

						<a
							onClick={() => {
								setEmbedOptionsModal(false);
								setEmbedRegisterOptionsModal(true);
							}}
						>
							<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
								<div className="flex w-full justify-between items-center mb-3">
									<Globe className="text-blue-600" />
									<ChevronRight className="text-gray-600 text-sm" size={18} />
								</div>
								<h4 className="text-base mb-0">Registration Form</h4>
								<p className="my-0 text-gray-600 text-sm">
									Embed client registration form on your website
								</p>
							</div>
						</a>
					</Modal>

					{/* Login Modal */}
					<Modal open={embedLoginModal} footer={null} onCancel={() => setEmbedLoginModal(false)}>
						<Title level={4}>Login Form Integration</Title>
						<p className="text-sm mb-4">
							Allow your clients to access their dashboard directly from your website.
						</p>

						<div className="mb-6">
							<p className="text-sm font-medium mb-2">Direct URL</p>
							<Input
								value={`${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_DASHBOARD}?code=${linkData?.link}`}
								readOnly
								suffix={
									<CopyOutlined
										className="cursor-pointer text-gray-500 hover:text-gray-700"
										onClick={() => {
											if (linkData?.link) {
												navigator.clipboard.writeText(
													`${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_DASHBOARD}?code=${linkData.link}`,
												);
												notification.success({ message: 'URL copied successfully' });
											}
										}}
									/>
								}
							/>
						</div>

						<Divider />

						<div>
							<p className="text-sm font-medium mb-2">Embed Iframe</p>
							<p className="text-sm text-gray-600 mb-3">
								Copy and paste this code to embed the login form directly on your website
							</p>
							<Input
								value={`<iframe src="${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_DASHBOARD}?code=${linkData?.link}" width="100%" height="100%" frameBorder="0"></iframe>`}
								readOnly
								suffix={
									<CopyOutlined
										className="cursor-pointer text-gray-500 hover:text-gray-700"
										onClick={() => handleCopyIframe(AppRoutes.UNBRANDED_DASHBOARD)}
									/>
								}
							/>
						</div>
					</Modal>

					{/* Registration Options Modal */}
					<Modal
						open={embedRegisterOptionsModal}
						footer={null}
						onCancel={() => {
							setEmbedRegisterOptionsModal(false);
							setRegistrationType(null);
							setShowFeatureGating(false);
							setShowAutoScale(false);
							setEmbedType(null);
						}}
					>
						{!embedType ? (
							<>
								<h3 className="mb-4 font-semibold text-xl">Choose Integration Type</h3>
								<p className="text-sm mb-4">
									Select whether you want to embed login or registration pages on your website.
								</p>

								<a onClick={() => setEmbedType('login')}>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<User className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Login Form</h4>
										<p className="my-0 text-gray-600 text-sm">
											Embed client login form on your website
										</p>
									</div>
								</a>

								<a onClick={() => setEmbedType('register')}>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<PlusCircle className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Registration Form</h4>
										<p className="my-0 text-gray-600 text-sm">
											Embed client registration form on your website
										</p>
									</div>
								</a>
							</>
						) : embedType === 'login' ? (
							<>
								<div className="flex items-center mb-4">
									<Button
										type="text"
										icon={<ChevronRight className="rotate-180 w-4 h-4" />}
										onClick={() => setEmbedType(null)}
									>
										Back
									</Button>
								</div>
								<h3 className="mb-4 font-semibold text-xl">Customer Login Integration</h3>
								<p className="text-sm mb-4">
									Allow your customers to access their dashboard directly from your website.
								</p>
								{resellerData?.customDomain && (
									<>
										<div className="mb-6">
											<p className="text-sm font-medium mb-2">Custom Domain URL</p>
											<Input
												value={`https://${resellerData?.customDomain}/login`}
												readOnly
												suffix={
													<CopyOutlined
														className="cursor-pointer text-gray-500 hover:text-gray-700"
														onClick={() => {
															if (linkData?.link) {
																navigator.clipboard.writeText(
																	`https://${resellerData?.customDomain}/login`,
																);
																notification.success({ message: 'URL copied successfully' });
															}
														}}
													/>
												}
											/>
										</div>
										<Divider />
									</>
								)}

								<div className="mb-6">
									<p className="text-sm font-medium mb-2">Direct URL</p>
									<Input
										value={`${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_DASHBOARD}?code=${linkData?.link}`}
										readOnly
										suffix={
											<CopyOutlined
												className="cursor-pointer text-gray-500 hover:text-gray-700"
												onClick={() => {
													if (linkData?.link) {
														navigator.clipboard.writeText(
															`${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_DASHBOARD}?code=${linkData.link}`,
														);
														notification.success({ message: 'URL copied successfully' });
													}
												}}
											/>
										}
									/>
								</div>

								<Divider />

								<div>
									<p className="text-sm font-medium mb-2">Embed Iframe</p>
									<p className="text-sm text-gray-600 mb-3">
										Copy and paste this code to embed the login form directly on your website
									</p>
									<Input
										value={`<iframe src="${import.meta.env.VITE_APP_WIHTELABEL_URL}${AppRoutes.UNBRANDED_DASHBOARD}?code=${linkData?.link}" width="100%" height="100%" frameBorder="0"></iframe>`}
										readOnly
										suffix={
											<CopyOutlined
												className="cursor-pointer text-gray-500 hover:text-gray-700"
												onClick={() => handleCopyIframe(AppRoutes.UNBRANDED_DASHBOARD)}
											/>
										}
									/>
								</div>

								{resellerData?.customDomain && (
									<>
										<Divider className="my-4" />
										<div className="flex justify-between items-center border-2 border-gray-300 mt-3 p-4 rounded-lg">
											<div>
												<h4 className="text-base mb-0">
													Default Registration{' '}
													<Tooltip title="If a prospect arrives to your login page, you can decide whether they would be redirected to create a free trial with 15 test free calls, or a paid account when they click on Register now.">
														<InfoCircleOutlined />
													</Tooltip>
												</h4>
												<span>Redirect potential clients when they click on Register now </span>
											</div>
											<Switch
												onChange={(checked) => {
													setDefaultRegisterPageLoading(true);
													updateDefaultRegistrationMutation({
														defaultRegistration: checked ? 'Paid' : 'Trial',
													});
												}}
												checkedChildren="Paid"
												unCheckedChildren="Trial"
												defaultChecked={resellerData?.defaultRegistration === 'Paid' ? true : false}
												loading={defaultRegisterPageLoading}
												disabled={isPending}
											/>
										</div>
									</>
								)}
							</>
						) : !registrationType ? (
							<>
								<div className="flex items-center mb-4">
									<Button
										type="text"
										icon={<ChevronRight className="rotate-180 w-4 h-4" />}
										onClick={() => {
											setEmbedType(null);
											setShowFeatureGating(false);
											setShowAutoScale(false);
										}}
									>
										Back
									</Button>
								</div>
								<h3 className="mb-4 font-semibold text-xl">Choose Registration Type</h3>
								<p className="text-sm mb-4">
									Select whether you want to set up registration for trial or paid customers.
								</p>

								<a
									onClick={() => {
										setRegistrationType('paid');
										setShowFeatureGating(false);
										setShowAutoScale(false);
									}}
								>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<CircleDollarSign className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Paid Registration</h4>
										<p className="my-0 text-gray-600 text-sm">
											For clients ready to purchase a subscription
										</p>
									</div>
								</a>

								<a
									onClick={() => {
										setRegistrationType('trial');
										setShowFeatureGating(false);
										setShowAutoScale(false);
									}}
								>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<Tag className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Trial Registration</h4>
										<p className="my-0 text-gray-600 text-sm">
											For clients who want to try the service first
										</p>
									</div>
								</a>
							</>
						) : !showFeatureGating ? (
							<>
								<div className="flex items-center mb-4">
									<Button
										type="text"
										icon={<ChevronRight className="rotate-180 w-4 h-4" />}
										onClick={() => setRegistrationType(null)}
									>
										Back
									</Button>
								</div>
								<h3 className="mb-4 font-semibold text-xl">Feature Gating</h3>
								<p className="text-sm mb-4">
									Would you like to customize which features are available to your clients during
									registration?
								</p>

								<a
									onClick={() => {
										dispatch(
											openModal({
												modalId: MODAL_IDS.FEATURE_GATING_CUSTOMIZE_MODAL,
												data: { isTrialForm: registrationType === 'trial' },
											}),
										);
									}}
								>
									<div className="border-2 border-gray-300 mt-3 p-4 rounded-lg">
										<div className="flex w-full justify-between items-center mb-3">
											<SparklesIcon className="text-blue-600" />
											<ChevronRight className="text-gray-600 text-sm" size={18} />
										</div>
										<h4 className="text-base mb-0">Customize Features</h4>
										<p className="my-0 text-gray-600 text-sm">
											Select which features will be available to your clients
										</p>
									</div>
								</a>

								<div className="flex justify-end mt-4">
									<Button
										type="primary"
										onClick={() => {
											setShowFeatureGating(true);
											if (registrationType === 'trial') {
												setShowAutoScale(true);
											}
										}}
									>
										Next
									</Button>
								</div>
							</>
						) : registrationType === 'paid' && !showAutoScale ? (
							<>
								<div className="flex items-center mb-4">
									<Button
										type="text"
										icon={<ChevronRight className="rotate-180 w-4 h-4" />}
										onClick={() => setShowFeatureGating(false)}
									>
										Back
									</Button>
								</div>
								<h3 className="mb-4 font-semibold text-xl">Auto-Scale Registration</h3>
								<p className="text-sm mb-4">
									Auto-scale automatically increases your seat count when a new client registers,
									even if you've reached your current limit. The additional seat cost will be added
									to your next bill.
								</p>

								<div className="flex items-center justify-between p-4 border-2 border-gray-300 rounded-lg">
									<div>
										<h4 className="text-base mb-1">Enable Auto-Scale</h4>
										<p className="text-sm text-gray-600 my-0">
											Automatically add seats when needed
										</p>
									</div>
									<Switch
										checked={autoScaleEnabled}
										onChange={handleAutoScaleChange}
										loading={isAutoScaleUpdating}
										disabled={isAutoScaleUpdating}
									/>
								</div>

								<div className="flex justify-end mt-4">
									<Button
										type="primary"
										onClick={() => setShowAutoScale(true)}
										disabled={isAutoScaleUpdating}
									>
										Next
									</Button>
								</div>
							</>
						) : (
							<>
								<div className="flex items-center mb-4">
									<Button
										type="text"
										icon={<ChevronRight className="rotate-180 w-4 h-4" />}
										onClick={() =>
											registrationType === 'paid'
												? setShowAutoScale(false)
												: setShowFeatureGating(false)
										}
									>
										Back
									</Button>
								</div>
								<h3 className="mb-4 font-semibold text-xl">Registration Link</h3>
								<p className="text-sm mb-4">
									{registrationType === 'trial'
										? 'Use this link to allow clients to register for a trial account.'
										: 'Use this link to allow clients to register for a paid account. Make sure to place this behind a paywall or protected area of your website.'}
								</p>

								{resellerData?.customDomain &&
									(() => {
										const urlPath =
											registrationType === 'trial'
												? AppRoutes.UNBRANDED_CLIENT_TRIAL
												: AppRoutes.GENERIC_DOMAIN_REGISTER;

										const fullUrl = `https://${resellerData?.customDomain}${urlPath}`;

										return (
											<>
												<div className="mb-6">
													<p className="text-sm font-medium mb-2">Custom Domain URL</p>
													<Input
														value={fullUrl}
														readOnly
														suffix={
															<CopyOutlined
																className="cursor-pointer text-gray-500 hover:text-gray-700"
																onClick={() => {
																	if (linkData?.link) {
																		navigator.clipboard.writeText(fullUrl);
																		notification.success({ message: 'URL copied successfully' });
																	}
																}}
															/>
														}
													/>
												</div>
												<Divider />
											</>
										);
									})()}

								<div className="mb-6">
									<p className="text-sm font-medium mb-2">Direct URL</p>
									<Input
										value={`${import.meta.env.VITE_APP_WIHTELABEL_URL}${
											registrationType === 'trial'
												? AppRoutes.UNBRANDED_CLIENT_TRIAL
												: AppRoutes.GENERIC_DOMAIN_REGISTER
										}?code=${linkData?.link}`}
										readOnly
										suffix={
											<CopyOutlined
												className="cursor-pointer text-gray-500 hover:text-gray-700"
												onClick={() => {
													if (linkData?.link) {
														navigator.clipboard.writeText(
															`${import.meta.env.VITE_APP_WIHTELABEL_URL}${
																registrationType === 'trial'
																	? AppRoutes.UNBRANDED_CLIENT_TRIAL
																	: AppRoutes.GENERIC_DOMAIN_REGISTER
															}?code=${linkData.link}`,
														);
														notification.success({ message: 'URL copied successfully' });
													}
												}}
											/>
										}
									/>
								</div>

								<Divider />

								<div>
									<p className="text-sm font-medium mb-2">Embed Iframe</p>
									<p className="text-sm text-gray-600 mb-3">
										Copy and paste this code to embed the registration form directly on your website
									</p>
									<Input
										value={`<iframe src="${import.meta.env.VITE_APP_WIHTELABEL_URL}${
											registrationType === 'trial'
												? AppRoutes.UNBRANDED_CLIENT_TRIAL
												: AppRoutes.GENERIC_DOMAIN_REGISTER
										}?code=${linkData?.link}" width="100%" height="100%" frameBorder="0"></iframe>`}
										readOnly
										suffix={
											<CopyOutlined
												className="cursor-pointer text-gray-500 hover:text-gray-700"
												onClick={() =>
													registrationType === 'trial'
														? handleTrialCopyIframe()
														: handleCopyIframe(AppRoutes.GENERIC_DOMAIN_REGISTER)
												}
											/>
										}
									/>
								</div>
							</>
						)}
					</Modal>
					<TutorialsModal
						isOpen={isTutorialsModalOpen}
						onClose={() => setIsTutorialsModalOpen(false)}
						tutorialItems={tutorialItems}
					>
						<TourButton onClick={handleTourClick} page="receptionist" />
					</TutorialsModal>

					{/* Cancel Subscription Warning Modal */}
					<CustomModal
						title="Warning"
						isModalOpen={cancelSubscriptionWarningModal}
						confirmAction={() => {
							stripeSubscriptionUpdateMutation.mutate({
								username: resellerData?.emailAddress as string,
								action: 'subscription_cancel',
								reseller: true,
							});
							setCancelSubscriptionWarningModal(false);
						}}
						cancelAction={() => {
							setCancelSubscriptionWarningModal(false);
						}}
						okText="Yes, Cancel Subscription"
						okButtonProps={{ danger: true }}
					>
						<Title level={4}>Are you sure you want to cancel your subscription?</Title>
						<Text className="text-gray-600">
							This action cannot be undone. Your subscription will be cancelled and you will loose
							access to all features at the end of billing cycle.
						</Text>
					</CustomModal>

					{/* End Trial Warning Modal */}
					<CustomModal
						title="Warning"
						isModalOpen={endTrialWarningModal}
						confirmAction={() => {
							endTrialMutation.mutate(resellerData?.inboundSubscriptionId as string);
							setEndTrialWarningModal(false);
						}}
						cancelAction={() => {
							setEndTrialWarningModal(false);
						}}
						okText="Yes, End Trial"
					>
						<Title level={4}>Are you sure you want to end your trial?</Title>
						<Text className="text-gray-600">
							By ending your trial now, you'll transition to a full subscription. Your first payment
							will be processed immediately.
						</Text>
					</CustomModal>

					<CustomModal
						title="Client Details"
						isModalOpen={showClientDetailsModal}
						confirmAction={() => setShowClientDetailsModal(false)}
						okText="Close"
						cancelButtonProps={{ style: { display: 'none' } }}
					>
						{selectedClientDetails && (
							<div className="space-y-4">
								<div className="flex items-center justify-between border-b pb-3">
									<div>
										<Typography.Text strong className="text-gray-600 block mb-1">
											Username
										</Typography.Text>
										<Typography.Text>{selectedClientDetails.accountInfo?.username}</Typography.Text>
									</div>
									<Button
										type="text"
										icon={<CopyOutlined />}
										onClick={() => {
											navigator.clipboard.writeText(selectedClientDetails.accountInfo?.username);
											notification.success({
												message: 'Username copied to clipboard',
												placement: 'topRight',
												duration: 2,
											});
										}}
										size="small"
									/>
								</div>
								<div className="flex items-center justify-between border-b pb-3">
									<div>
										<Typography.Text strong className="text-gray-600 block mb-1">
											Business Name
										</Typography.Text>
										<Typography.Text>
											{selectedClientDetails.accountInfo?.businessName as string}
										</Typography.Text>
									</div>
									<Button
										type="text"
										icon={<CopyOutlined />}
										onClick={() => {
											navigator.clipboard.writeText(
												selectedClientDetails.accountInfo?.businessName as string,
											);
											notification.success({
												message: 'Business name copied to clipboard',
												placement: 'topRight',
												duration: 2,
											});
										}}
										size="small"
									/>
								</div>
								<div className="flex items-center justify-between border-b pb-3">
									<div>
										<Typography.Text strong className="text-gray-600 block mb-1">
											Business Type
										</Typography.Text>
										<Typography.Text>{selectedClientDetails.businessType}</Typography.Text>
									</div>
									<Button
										type="text"
										icon={<CopyOutlined />}
										onClick={() => {
											navigator.clipboard.writeText(selectedClientDetails.businessType);
											notification.success({
												message: 'Business type copied to clipboard',
												placement: 'topRight',
												duration: 2,
											});
										}}
										size="small"
									/>
								</div>
								<div className="flex items-center justify-between border-b pb-3">
									<div>
										<Typography.Text strong className="text-gray-600 block mb-1">
											Email Address
										</Typography.Text>
										<Typography.Text>
											{selectedClientDetails.accountInfo?.emailAddress}
										</Typography.Text>
									</div>
									<Button
										type="text"
										icon={<CopyOutlined />}
										onClick={() => {
											navigator.clipboard.writeText(
												selectedClientDetails.accountInfo?.emailAddress as string,
											);
											notification.success({
												message: 'Email address copied to clipboard',
												placement: 'topRight',
												duration: 2,
											});
										}}
										size="small"
									/>
								</div>
								<div className="flex items-center justify-between border-b pb-3">
									<div>
										<Typography.Text strong className="text-gray-600 block mb-1">
											Testing Number
										</Typography.Text>
										<Typography.Text>{selectedClientDetails.testing_number}</Typography.Text>
									</div>
									<Button
										type="text"
										icon={<CopyOutlined />}
										onClick={() => {
											navigator.clipboard.writeText(selectedClientDetails.testing_number);
											notification.success({
												message: 'Testing number copied to clipboard',
												placement: 'topRight',
												duration: 2,
											});
										}}
										size="small"
									/>
								</div>
							</div>
						)}
					</CustomModal>
				</div>
			)}

			<ResellerTour tourSteps={receptionistTourSteps} />
		</ResellerDashboard>
	);
}
